module.exports = __webpack_public_path__ + "static/product-lims-detail-af465881fb460ccfad4ed9d3194bc755.png";